import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
import { createBrowserHistory } from "history";
import { Snacks } from "lego-gui-lib/lib";
import { LegoProvider } from "lego-gui-lib/lib/model/Provider";
import { configure } from "mobx";
import { observer } from "mobx-react-lite";
import { syncHistoryWithStore } from "mobx-react-router";
import React, { FC, Suspense, useContext, useMemo, useState } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { Admin } from "./common/Admin";
import { AuthenticatedView } from "./common/AuthenticatedView";
import {
  LoginFailedRedirectView,
  LoginRedirectView
} from "./common/LoginRedirectView";
import { LogoutRedirectView } from "./common/LogoutRedirectView";
import { mainStore } from "./core/mainStore";
import { createTheme } from "./core/theme";
import { Loader } from "./common/loadingComponent";
import { versionContext } from "./core/model/version";

const App: FC = observer(() => {
  configure({ enforceActions: "observed" });

  /** Used to globally apply search params persistence on IndexViews */
  mainStore.router.applyPersistParams();

  const basename = process.env.PUBLIC_URL;
  const browserHistory = createBrowserHistory({
    basename: basename
  });
  /* state has to be wrapped in useState hook, as it should not change on rerender if not necessary */
  const [history] = useState(
    syncHistoryWithStore(browserHistory, mainStore.router)
  );
  const version = useContext(versionContext);
  const theme = useMemo(() => createTheme(version.apiVersion.backgroundColor), [
    version.apiVersion
  ]);

  return (
    <Suspense fallback={<Loader />}>
      <LegoProvider {...mainStore}>
        {/*eslint-disable-next-line react/jsx-no-undef */}
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <div className="container">
            <Router history={history}>
              <Switch>
                <Route path="/admin" render={() => <Admin />} />
                <Route path="/admin/sans" />
                <Route
                  path="/loginRedirect"
                  render={() => <LoginRedirectView />}
                />
                <Route
                  path="/loginFailed"
                  render={() => <LoginFailedRedirectView />}
                />
                <Route
                  path="/logoutRedirect"
                  render={() => <LogoutRedirectView />}
                />
                <Redirect
                  to={`/admin${mainStore.auth.landingPage}`}
                  from=""
                  exact={true}
                />
              </Switch>
              <Route
                path="/admin"
                exact={false}
                render={() => <AuthenticatedView />}
              />
            </Router>
            <Snacks />
          </div>
        </MuiThemeProvider>
      </LegoProvider>
    </Suspense>
  );
});

export default App;
